import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule, KeycloakAngularModule } from 'keycloak-angular';
import { ConfirmationService, MessageService } from 'primeng/api/';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { PaginatorModule } from 'primeng/paginator';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SpinnerModule } from 'primeng/spinner';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { AppRoutingModule } from '../../../app/app-routing.module';
import { IwDashboardComponent } from './iw-dashboard/iw-dashboard.component';
import { IwNewTenantComponent } from './iw-new-tenant/iw-new-tenant.component';
import { IwOptionsUsersComponent } from './iw-options-users/iw-options-users.component';
import { IwUserGridComponent } from './iw-user-grid/iw-user-grid.component';
import { IwStatisticsComponent } from './iw-statistics/iw-statistics.component';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import {IwUuidGridComponent} from "./iw-uuid-grid/iw-uuid-grid.component";
import {IwNewUuidComponent} from "./iw-new-uuid/iw-new-uuid.component";


@NgModule({
  declarations: [
    IwUserGridComponent,
    IwNewTenantComponent,
    IwNewUuidComponent,
    IwDashboardComponent,
    IwOptionsUsersComponent,
    IwStatisticsComponent,
    IwUuidGridComponent,
  ],
  imports: [
    FormsModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    TableModule,
    InputTextareaModule,
    DialogModule,
    CalendarModule,
    DropdownModule,
    SpinnerModule,
    InputTextModule,
    KeycloakAngularModule,
    CoreModule,
    TabViewModule,
    ButtonModule,
    AppRoutingModule,
    ToastModule,
    ConfirmDialogModule,
    CheckboxModule,
    SelectButtonModule,
    TranslateModule,
    PaginatorModule,
    FormsModule,
    ReactiveFormsModule,
    InputNumberModule,
  ],
  providers: [
    MessageService,
    ConfirmationService,
    FormBuilder,
  ],
  exports: [
    IwUserGridComponent,
    IwNewTenantComponent,
    IwNewUuidComponent,
    IwDashboardComponent,
    IwOptionsUsersComponent,
    IwStatisticsComponent,
    IwUuidGridComponent,
  ],
})
export class IwComponentsModule {}
